/**
 * The only place the product name lives. Change it here and it changes
 * everywhere - title bar, sign-in screen, PWA manifest, printed sheets.
 *
 * `name` is used wherever the name appears in a sentence. `shortName` is for
 * places with no room: the iPhone home screen truncates at roughly twelve
 * characters, so the full name would be cut mid-word.
 */
export const BRAND = {
  name: 'FESK Fleet Management',
  shortName: 'FESK Fleet',

  /**
   * The logotype, split into parts the wordmark can weight differently and
   * stack. Rendered in caps. `sub` sits on a second line at full size and is
   * dropped in tight spots, where the mark reads as "FESK FLEET".
   */
  wordmark: { lead: 'FESK', tail: 'Fleet', sub: 'Management' },

  strapline: 'Safety inspections, defects and maintenance records for HGV workshops.',

  /** Shown in the footer of a printed inspection sheet. */
  legalNote:
    'This record is based on the RHA Safety Inspection and Maintenance Record forms and the DVSA Guide to Maintaining Roadworthiness.',
} as const;
